import axios from 'axios'
import { DATAMASTER_ENDPOINT } from '../../endpoints'


export const addDepeciationAndVariationByModelYear = async (model_id, year, depreciation_value, version_price, year_version, datamaster_id) => {
  const body = {
    year,
    depreciation_value,
    version_price, 
    year_version, 
    datamaster_id
  }
  try{
    return await axios.post(`${DATAMASTER_ENDPOINT}/addDepeciationAndVariationByModelYear/${model_id}`, body)
  }catch(error){
    console.log(error)
    throw new Error(error)
  }
}